
import { useState } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { SpotifyTrack, TrackDownload } from '@/lib/types';
import { performUpload } from './utils/uploadProcessUtils';

export function useUploadProcess(artistId: string | null, onUploadSuccess: (upload: TrackDownload) => void) {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const { toast } = useToast();

  const handleUpload = async (
    e: React.FormEvent,
    spotifyUrl: string, 
    selectedFile: File | null,
    trackPreview: SpotifyTrack | null,
    validateSpotifyUrl: (url: string) => boolean,
    trackTitle?: string,
    trackDescription?: string
  ) => {
    setIsUploading(true);
    
    try {
      const result = await performUpload(
        e,
        spotifyUrl,
        selectedFile,
        trackPreview,
        validateSpotifyUrl,
        artistId,
        toast,
        setUploadError,
        trackTitle,
        trackDescription
      );
      
      if (result.success && result.upload) {
        onUploadSuccess(result.upload);
      }
      
      return result;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    isUploading,
    uploadError,
    handleUpload,
  };
}
